import { Component, OnInit, Input } from '@angular/core';
import { AppSettings } from '../app.settings';

@Component({
  selector: 'option-button',
  template: `
    <label
      class="btn w-100"
      [ngClass]="
        item.value == selected ? 'btn-primary' : 'btn-outline-secondary'
      "
      [attr.aria-label]="item.text + ' ' + item.value"
    >
      <div class="block">{{ item.text }}</div>
      <input
        type="radio"
        name="donation-amount"
        [value]="item.value"
        id="donation-amount-1"
        hidden
        [(ngModel)]="selected"
      />
      {{ item.value | currency: currencyCode:'symbol-narrow':'1.2-2' }}
    </label>
  `
})
export class OptionButtonComponent implements OnInit {
  selected;
  @Input() item: any = {};
  currencyCode = 'USD';

  constructor(private settings: AppSettings) {
    this.currencyCode = this.settings.getValue('organization').currency_code;
  }

  ngOnInit() {}
}
